"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = exports.LayoutColumn = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _defaultTheme = _interopRequireDefault(require("../defaultTheme"));
var _Grid = _interopRequireDefault(require("../utils/Grid"));
var _consts = require("./consts");
var _mediaQuery = _interopRequireDefault(require("../utils/mediaQuery"));
var _LayoutColumn = _interopRequireDefault(require("./LayoutColumn"));
exports.LayoutColumn = _LayoutColumn.default;
const getChildrenProps = (type, key) => {
  if (_consts.LAYOUT_SETTINGS[type].layoutColumns && _consts.LAYOUT_SETTINGS[type].layoutColumns[key]) {
    return _consts.LAYOUT_SETTINGS[type].layoutColumns[key];
  }
  return null;
};
const StyledLayout = (0, _styledComponents.default)(_Grid.default).withConfig({
  displayName: "Layout__StyledLayout",
  componentId: "sc-co0t0u-0"
})(["box-sizing:border-box;margin:0 auto;width:100%;padding:0 ", ";", ";"], ({
  theme
}) => theme.orbit.spaceMedium, _mediaQuery.default.desktop((0, _styledComponents.css)(["padding:", ";"], ({
  theme
}) => theme.orbit.spaceLarge)));
StyledLayout.defaultProps = {
  theme: _defaultTheme.default
};
const Layout = ({
  children,
  type,
  dataTest
}) => /*#__PURE__*/React.createElement(StyledLayout, (0, _extends2.default)({}, _consts.LAYOUT_SETTINGS[type], {
  dataTest: dataTest
}), React.Children.map(children, (item, key) => {
  return /*#__PURE__*/React.cloneElement(item, {
    ...getChildrenProps(type, key.toString()),
    ...item.props
  });
}));
var _default = Layout;
exports.default = _default;